module.exports = __webpack_public_path__ + "prod/1.42.2/img/paySuccess-h5.c783c3fa.svg";